import React, { useEffect, useRef } from "react";
import {
  Tooltip,
  makeStyles,
  TableCell,
  TableRow,
  TableCellLayout,
  PopoverTrigger,
  Popover,
  PopoverSurface,
} from "@fluentui/react-components";
import { useState } from "react";
import {
  FlagIcon,
  MeatBallsMenuIcon,
  MeetingsClockIcon,
  PlusIcon,
} from "../../../../../modules/default-svg";
import { tConverter } from "../../../../../helpers/utils";
import CustomInput from "../../../input/customInput/CustomInput";
import {
  createShiftRequest,
  updateShiftRequest,
} from "../../../../../store/actions/shifts.actions";
import { useDispatch } from "react-redux";
import { generalActions } from "../../../../../store/actions";

const useStyles = makeStyles({
  tooltip: {
    backgroundColor: "#342c82",
    color: "#FFFFFF",
  },
});

const ShiftRow = (props) => {
  const {
    sortingCriteria,
    data,
    handleModal,
    menu,
    sortShiftRequest,
    updateFlag,
    columnConfig,
  } = props;
  const [sortedData, setSortedData] = useState([]);
  const [flagged, setFlagged] = useState([]);
  const [popoverOpen, setPopoverOpen] = useState("");
  const [isEditRecord, setIsEditRecord] = useState(null);
  const [formErrors, setFormErrors] = useState({
    name: "",
  });
  const popoverRef = useRef(null);
  const nameInputRef = useRef(null);
  const startDateInputRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (sortingCriteria.column !== null) {
      sortShiftRequest({
        page: 1,
        size: 10,
        orderBy: `${sortingCriteria.column} ${sortingCriteria.order}`,
      });
    }
  }, [sortingCriteria]);

  useEffect(() => {
    if (typeof data != "string") {
      data
        .filter((d) => d.isFlagged)
        .map((f) => {
          if (!flagged.includes(f.id)) {
            setFlagged((prevItems) => [...prevItems, f.id]);
          }
        });
      const tempData = [...data];
      tempData.push({ name: "", startTime: "", endTime: "" });
      setSortedData(tempData);
    }
  }, [data]);

  useEffect(() => {
    if (menu.props.closePopover) {
      setPopoverOpen(null);
    }
  }, [menu.props.closePopover]);

  const handlePopoverOpen = (rowId) => {
    setPopoverOpen(rowId);
  };

  const handleClickOutside = (event) => {
    if (
      popoverRef.current &&
      !popoverRef.current.contains(event.target) &&
      event.target?.innerText !== "Edit" &&
      event.target?.innerText !== "Delete" &&
      event.target?.innerText !== "Remind me" &&
      event?.target?.tagName !== "svg"
    ) {
      handlePopoverOpen(null);
    }
    if (
      isEditRecord &&
      event.target.localName !== "input" &&
      event.target.localName !== "div" &&
      event.target.tagName.toLowerCase() != "li"
    ) {
      handleBlur();
    } else if (isEditRecord && event.target.placeholder === "Search") {
      handleBlur();
    }
  };

  const handleScroll = (e) => {
    handlePopoverOpen(null);
  };

  const handleBlur = () => {
    let data = { ...isEditRecord?.name };
    if (data.name && data.startTime && data.endTime) {
      if (data.id) {
        dispatch(
          updateShiftRequest({
            id: sortedData[isEditRecord.index].id,
            payload: data,
          })
        );
      } else {
        dispatch(createShiftRequest({ payload: data }));
      }
    } else {
      const errors = {};
      if (!data.name) {
        errors["name"] = `The Name field is required.`;
        setFormErrors(errors);
        return dispatch(
          generalActions.showToast({
            title: "name is a required field",
            type: "error",
          })
        );
      }
    }
    setIsEditRecord(null);
  };

  const handleEditable = (event) => {
    if (event.key === "Escape") {
      setIsEditRecord(null);
    } else if (event.key === "Enter") {
      if (isEditRecord) {
        handleBlur();
      }
    }
  };

  const handleInputChange = (value, type) => {
    const data = JSON.parse(JSON.stringify(isEditRecord));
    let error = { ...formErrors };
    if (type === "name") {
      error["name"] = "";
      setFormErrors(error);
      data.name.name = value;
      setIsEditRecord(data);
    } else if (type === "startTime") {
      data.name.startTime = value;
      setIsEditRecord(data);
    } else if (type === "endTime") {
      data.name.endTime = value;
      setIsEditRecord(data);
    }
  };

  const handleIsEdiRecord = (index, type) => {
    setIsEditRecord({ index: index, name: sortedData[index] });
    setTimeout(() => {
      switch (type) {
        case "name":
          nameInputRef.current?.focus();
          break;
        case "startTime":
          startDateInputRef.current?.focus();
          break;
      }
    }, 0);
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("wheel", handleScroll);
    document.addEventListener("keydown", handleEditable);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("wheel", handleScroll);
      document.removeEventListener("keydown", handleEditable);
    };
  }, [isEditRecord]);

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////

  const addFlag = (id) => {
    setFlagged((prevItems) => [...prevItems, id]);
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: true,
        },
      ],
    });
  };

  const removeFlag = (id) => {
    setFlagged((prevItems) => prevItems.filter((item) => item !== id));
    updateFlag({
      id: id,
      payload: [
        {
          op: "replace",
          path: "/IsFlagged",
          value: false,
        },
      ],
    });
  };

  useEffect(() => {
    const sortedArray = data;
    const tempData = [...sortedArray];
    tempData.push({ name: "", startTime: "", endTime: "" });
    setSortedData(tempData);
  }, [flagged]);

  const sortDataByFlagged = (dataArray, flaggedArray) => {
    const flaggedItems = [];
    const remainingItems = [];

    dataArray.forEach((item) => {
      if (flaggedArray.includes(item.id)) {
        flaggedItems.push(item);
      } else {
        remainingItems.push(item);
      }
    });

    flaggedItems.sort((a, b) => {
      return flaggedArray.indexOf(a.id) - flaggedArray.indexOf(b.id);
    });

    return [...flaggedItems, ...remainingItems];
  };

  ///////////////////////// FLAGGED fUNCTIONALITY /////////////////////////
  const sortedColumnConfig = [...columnConfig].sort(
    (a, b) => a.order - b.order
  );

  const renderTableCell = (item, index, column) => {
    const isEditing = isEditRecord && isEditRecord.index === index;

    switch (column.label) {
      case "Shift Name":
        return (
          <TableCell>
            <div className="d-flex justify-content-between align-items-center">
              <div className="d-flex align-items-center inputWidth">
                {item?.id && (
                  <Tooltip
                    positioning="before"
                    content={{
                      children: flagged.includes(item.id) ? "Unflag" : "Flag",
                      className: styles.tooltip,
                    }}
                    relationship="label"
                    withArrow
                  >
                    <span
                      className={`flag ${
                        flagged.includes(item.id) ? "flagActive" : ""
                      }`}
                      onClick={() =>
                        flagged.includes(item.id)
                          ? removeFlag(item.id)
                          : addFlag(item.id)
                      }
                    >
                      <FlagIcon />
                    </span>
                  </Tooltip>
                )}
                {isEditing ? (
                  <CustomInput
                    placeholder="Enter Shift Name"
                    handleChange={(value) => handleInputChange(value, "name")}
                    type="text"
                    value={isEditRecord.name.name}
                    ref={nameInputRef}
                    errorMessage={formErrors.name}
                    displayErrorMessage={false}
                    width={"100%"}
                  />
                ) : (
                  <div
                    className="inputWidth"
                    onClick={() => handleIsEdiRecord(index, "name")}
                  >
                    {item?.id ? (
                      item.name
                    ) : (
                      <div className="d-flex _add_btn">
                        <PlusIcon />
                        Add
                      </div>
                    )}
                    {item.isDefault && (
                      <span className="pill purple m-2">Default shift</span>
                    )}
                  </div>
                )}
              </div>
              {item?.id && (
                <div className="flag">
                  <Popover
                    {...props}
                    open={popoverOpen === item.id}
                    onOpenChange={(isOpen) =>
                      isOpen && handlePopoverOpen(item.id)
                    }
                    positioning="below-start"
                  >
                    <PopoverTrigger disableButtonEnhancement>
                      <TableCellLayout
                        media={<MeatBallsMenuIcon />}
                        onClick={() => handleModal(item)}
                      />
                    </PopoverTrigger>
                    <PopoverSurface
                      tabIndex={-1}
                      className="listingPopoverWrapper"
                    >
                      {menu}
                    </PopoverSurface>
                  </Popover>
                </div>
              )}
            </div>
          </TableCell>
        );
      case "Hour Range":
        return isEditing ? (
          <TableCell>
            <div className="d-flex align-items-start w-100">
              <CustomInput
                inputwd="w-50 me-3"
                icon={<MeetingsClockIcon />}
                placeholder="00:00"
                value={isEditRecord.name.startTime}
                type="time"
                handleChange={(value) => handleInputChange(value, "startTime")}
                ref={startDateInputRef}
              />
              <CustomInput
                inputwd="w-50"
                icon={<MeetingsClockIcon />}
                placeholder="00:00"
                value={isEditRecord.name.endTime}
                type="time"
                handleChange={(value) => handleInputChange(value, "endTime")}
              />
            </div>
          </TableCell>
        ) : (
          <TableCell onClick={() => handleIsEdiRecord(index, "startTime")}>
            {item.startTime
              ? `${
                  JSON.parse(localStorage.getItem("settings")).regionalSettings
                    .timeFormat === "hh:mm"
                    ? item.startTime
                    : tConverter(item.startTime)
                } - ${
                  JSON.parse(localStorage.getItem("settings")).regionalSettings
                    .timeFormat === "hh:mm"
                    ? item.endTime
                    : tConverter(item.endTime)
                }`
              : ""}
          </TableCell>
        );
      default:
        return <TableCell></TableCell>;
    }
  };

  const styles = useStyles();
  return (
    <>
      {sortedData.length > 0 ? (
        sortedData.map((item, index) => (
          <TableRow key={item.id || `new-${index}`} ref={popoverRef}>
            {sortedColumnConfig
              .filter((column) => column.isVisible)
              .map((col) => renderTableCell(item, index, col))}
          </TableRow>
        ))
      ) : (
        <TableRow>
          <TableCell colSpan={sortedColumnConfig.length}>
            No data available
          </TableCell>
        </TableRow>
      )}
    </>
  );
};

export default ShiftRow;
